import React from "react";
import { Box ,Paper,Space} from "@mantine/core";
import { ReactComponent as Icon } from "../../assets/img/Epicc.svg";
import EhrConnect from "./Ehrconnect";



const Wear: React.FC = ({}) => {
const propsss = (
  <>
    Wear Type <span style={{ color: "red" }}>*</span>
  </>
);
  return (
    <Box>
      <Space h="md" />
      <Paper
        sx={{
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
      >
        <EhrConnect ehrorwear={propsss} wear={false} />
      </Paper>
    </Box>
  );
};

export default Wear;
